import { Level2MenuHead, Level2MenuItem } from "@/features";
import { RiTranslate } from "react-icons/ri";
import GroupIcon from "@mui/icons-material/Group";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import {
  permissionsTranslation,
  permissionsActiveUsers,
  permissionsSupportMenu,
} from "@/utils";

const parentPath = "support";

export const SupportMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={gettext("Support")}
      codes={permissionsSupportMenu}
      feature="common"
      icon={<RiTranslate size={18} className="mx-3" />}
    >
      <Level2MenuItem
        link={`/${parentPath}/translation`}
        label={gettext("Translation")}
        codes={permissionsTranslation}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/active-users`}
        label={gettext("Active Users")}
        codes={permissionsActiveUsers}
        feature="common"
        icon={<GroupIcon sx={{ fontSize: 18 }} />}
      />
    </Level2MenuHead>
  );
};
